<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <b-modal hide-footer size="lg" title="Existencias" v-model="modals.modal2">
      <div>
        <center>
          <multiselect
            v-model="producto_selected"
            :options="options_productos"
            placeholder="Buscar por código de producto"
            v-if="options_productos.length > 0"
            label="ItemCode"
            track-by="ItemCode"
            @select="dispatchActionProducto"
          ></multiselect>
          <div v-if="options_productos.length === 0">
            <img src="img/loader.gif" class="img-responsive" style="width:50px" />
            <br />Cargando productos...
          </div>
        </center>
      </div>
      <div v-if="showLoaderExistencia" style="padding-top:20px">
        <center>
          <img src="img/loader.gif" class="img-responsive" style="width:50px" />
          <br />Cargando existencia...
        </center>
      </div>
      <div v-if="showExistenciaResult" style="padding-top:25px">
        <h4>
          {{ producto_selected.ItemName }}
          <br />
          <span style="font-weight:normal">
            {{
            producto_selected.ItemCode
            }}
          </span>
        </h4>
        <div class="row" style="padding-top:8px">
          <base-table thead-classes="thead-light" :data="producto_selected.ItemWarehouseInfoCollection">
            <template slot="columns">
              <th><center>Almacén</center></th>
              <th><center>Stock</center></th>
              <th><center>Comprometido</center></th>
              <th></th>
            </template>
            <template slot-scope="{ row }">
              <th scope="row">
                <center>
                  <a style="font-size: 12px">{{ row.WarehouseCode }} </a>
                </center>
              </th>
              <th scope="row">
                <center>
                  <a style="font-size: 12px">{{ row.InStock }} </a>
                </center>
              </th>
              <th scope="row">
                <center>
                  <a style="font-size: 12px">{{ row.Committed }} </a>
                </center>
              </th>
            </template>
          </base-table>
          <div class="ml-4" v-if="producto_selected.ItemWarehouseInfoCollection.length == 0"><span style="font-size:13px">No hay existencias para este artículo</span></div>
          <div class="ml-3 mt-3">
            <h4>Llegadas de Importación</h4>
            <base-table thead-classes="thead-light" :data="producto_selected.llegadas">
              <template slot="columns">
                <th><center>OC</center></th>
                <th><center>CEDIS</center></th>
                <th><center>Cantidad</center></th>
                <th><center>Fecha de Llegada</center></th>
                <th></th>
              </template>
              <template slot-scope="{ row }">
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.PurchaseOrders.DocNum }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row['PurchaseOrders/DocumentLines'].U_Issue_ValidatedComment }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row['PurchaseOrders/DocumentLines'].RemainingOpenQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row['PurchaseOrders/DocumentLines'].ShipDate }} </a>
                  </center>
                </th>
              </template>
            </base-table>
            <div class="ml-4" v-if="!producto_selected.llegadas"><span style="font-size:13px">No hay llegadas de importación para este artículo</span></div>
          </div>
          
          <div class="ml-3 mt-3">
            <h4>Pedidos Pendientes de Surtir (PPS)</h4>
            <base-table thead-classes="thead-light" :data="producto_selected.pps">
              <template slot="columns">
                <th><center>Pedido</center></th>
                <th><center>Cliente</center></th>
                <th><center>Fecha</center></th>
                <th><center>Cantidad</center></th>
                <th></th>
              </template>
              <template slot-scope="{ row }">
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.Orders.DocNum }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.Orders.CardName }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.Orders.DocDate }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row['Orders/DocumentLines'].RemainingOpenQuantity }} </a>
                  </center>
                </th>
              </template>
            </base-table>
            <div class="ml-4" v-if="!producto_selected.pps"><span style="font-size:13px">No hay PPS para este artículo</span></div>
          </div>
        </div>
      </div>
    </b-modal>
    
    <modal :show.sync="modals.modal4">
      <h2 slot="header" class="modal-title" id="modal-title-default">Usuarios de Traslados</h2>
      <div class="row">
        <div class="col-sm-8">
          Busca un usuario:
          <br />
          <multiselect
            v-model="user_selected"
            :options="usersTraslados"
            placeholder="Buscar por nombre de usuario"
            v-if="usersTraslados.length > 0"
            label="nombre"
            track-by="nombre"
            @select="dispatchActionUser"
          ></multiselect>
        </div>
        <div class="col-sm-4" v-if="!showNewUser">
          <br />
          <base-button
            type="success"
            class="ml-auto"
            @click="showNewUser=true;showModifyUser=false"
          >Nuevo</base-button>
        </div>
      </div>
      <div class="row mt-3" v-if="showNewUser">
        <div class="col-sm-4">
          <label>Nombre</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_nombre"></base-input>
        </div>
        <div class="col-sm-4">
          <label>PIN</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_pin"></base-input>
        </div>
        <div class="col-sm-4">
          <label>CEDIS</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_cedis"></base-input>
        </div>
        <base-button type="success" class="ml-auto" @click="createUserTraslados">Crear usuario</base-button>
      </div>
      <div class="row mt-3" v-if="showModifyUser">
        <div class="col-sm-4">
          <label>Nombre</label>
          <base-input disabled class="input-group-alternative mb-3" v-model="user_selected.nombre"></base-input>
        </div>
        <div class="col-sm-4">
          <label>PIN</label>
          <base-input disabled class="input-group-alternative mb-3" v-model="user_selected.pin"></base-input>
        </div>
        <div class="col-sm-4">
          <label>CEDIS</label>
          <base-input disabled class="input-group-alternative mb-3" v-model="user_selected.cedis"></base-input>
        </div>
      </div>

      <template slot="footer">
        <base-button type="link" class="ml-auto" @click="modals.modal4 = false">Cerrar</base-button>
      </template>
    </modal>

    <modal :show.sync="modals.modal6">
      <h2 slot="header" class="modal-title" id="modal-title-default">Choferes</h2>
      <div class="row">
        <div class="col-sm-12">
          Busca un chofer:
          <br />
          <multiselect
            v-model="chofer_selected"
            :options="usersChoferes"
            placeholder="Buscar por nombre de chofer"
            v-if="usersChoferes.length > 0"
            label="nombre"
            track-by="nombre"
            @select="dispatchActionChofer"
          ></multiselect>
        </div>
      </div>
      <div class="row mt-3" v-if="showNewChofer">
        <div class="col-sm-4">
          <label>Nombre</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_nombre"></base-input>
        </div>
        <div class="col-sm-4">
          <label>PIN</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_pin"></base-input>
        </div>
        <div class="col-sm-4">
          <label>CEDIS</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_cedis"></base-input>
        </div>
        <base-button type="success" class="ml-auto" @click="createUserTraslados">Crear usuario</base-button>
      </div>
      <div class="row mt-3" v-if="showModifyChofer">
        <div class="col-sm-9">
          <label>Nombre</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.nombre"></base-input>
        </div>
        <div class="col-sm-3">
          <label>CEDIS</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.cedis"></base-input>
        </div>
      </div>
      <div class="row" v-if="showModifyChofer">
        <div class="col-sm-12">
          <label>Calle</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.calle"></base-input>
        </div>
        <div class="col-sm-4">
          <label>Numero Exterior</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.exterior"></base-input>
        </div>
        <div class="col-sm-4">
          <label>Colonia</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.colonia"></base-input>
        </div>
        <div class="col-sm-4">
          <label>Código Postal</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.codigo_postal"></base-input>
        </div>
      </div>
      <div class="row" v-if="showModifyChofer">
        <div class="col-sm-6">
          <label>RFC</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.rfc"></base-input>
        </div>
        <div class="col-sm-6">
          <label>Licencia</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.licencia"></base-input>
        </div>
        <div class="col-sm-6">
          <label>Teléfono</label>
          <base-input class="input-group-alternative mb-3" v-model="chofer_selected.telefono"></base-input>
        </div>
      </div>

      <div class="row" v-if="showModifyChofer">
        <div class="col-sm-12">
          <label>Vehiculo asignado</label> <br>
          <multiselect
            v-model="vehiculoDataChofer"
            :options="vehiculosList"
            placeholder="Seleccionar otro vehiculo"
            v-if="vehiculosList.length > 0"
            :custom-label="customVehiculos"
            @select="dispatchActionVehiculo"
          ></multiselect>
        </div>
      </div>


      <template slot="footer">
        <base-button
            type="success"
            
            @click="saveChangesChofer(chofer_selected)"
          >Guardar</base-button>
        <base-button type="link" @click="modals.modal6 = false">Cerrar</base-button>
      </template>
    </modal>

    <modal :show.sync="modals.modal7">
      <h2 slot="header" class="modal-title" id="modal-title-default">Vehiculos</h2>
      <div class="row">
        <div class="col-sm-12">
          Busca un vehiculo:
          <br />
          <multiselect
            v-model="vehiculo_selected"
            :options="vehiculos"
            placeholder="Buscar vehiculo"
            v-if="vehiculos.length > 0"
            label="placa"
            track-by="placa"
            :custom-label="customVehiculos"
          ></multiselect>
        </div>
      </div>
      <div class="row mt-3" v-if="vehiculo_selected.cedis === '- Nuevo vehiculo'">
        <div class="col-sm-4">
          <label>Marca</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.marca"></base-input>
        </div>
        <div class="col-sm-4">
          <label>Año</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.modelo"></base-input>
        </div>
        <div class="col-sm-4">
          <label>CEDIS</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.cedis"></base-input>
        </div>
      </div>
      <div class="row" v-if="vehiculo_selected.cedis === '- Nuevo vehiculo'">
        <div class="col-sm-12">
          <label>Aseguradora</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.aseguradora"></base-input>
        </div>
      </div>
      <div class="row" v-if="vehiculo_selected.cedis === '- Nuevo vehiculo'">
        <div class="col-sm-6">
          <label>No. Poliza</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.poliza"></base-input>
        </div>
        <div class="col-sm-6">
          <label>No. Placas</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.placa"></base-input>
        </div>
      </div>
      <div class="row" v-if="vehiculo_selected.cedis === '- Nuevo vehiculo'">
        <div class="col-sm-4">
          <label>PermSCT</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.PermSCT"></base-input>
        </div>
        <div class="col-sm-4">
          <label>NumPermisoSCT</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.NumPermisoSCT"></base-input>
        </div>
        <div class="col-sm-4">
          <label>Config vehicular</label>
          <base-input class="input-group-alternative mb-3" v-model="nuevo_vehiculo.configuracion_vehicular"></base-input>
        </div>
      </div>
      <div class="row mt-3" v-if="vehiculo_selected.cedis !== '- Nuevo vehiculo' && vehiculo_selected.cedis">
        <div class="col-sm-4">
          <label>Marca</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.marca"></base-input>
        </div>
        <div class="col-sm-4">
          <label>Año</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.modelo"></base-input>
        </div>
        <div class="col-sm-4">
          <label>CEDIS</label>
          <base-input disabled class="input-group-alternative mb-3" v-model="vehiculo_selected.cedis"></base-input>
        </div>
      </div>
      <div class="row" v-if="vehiculo_selected.cedis !== '- Nuevo vehiculo' && vehiculo_selected.cedis">
        <div class="col-sm-12">
          <label>Aseguradora</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.aseguradora"></base-input>
        </div>
      </div>
      <div class="row" v-if="vehiculo_selected.cedis !== '- Nuevo vehiculo' && vehiculo_selected.cedis">
        <div class="col-sm-6">
          <label>No. Poliza</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.poliza"></base-input>
        </div>
        <div class="col-sm-6">
          <label>No. Placas</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.placa"></base-input>
        </div>
      </div>
      <div class="row" v-if="vehiculo_selected.cedis !== '- Nuevo vehiculo' && vehiculo_selected.cedis">
        <div class="col-sm-4">
          <label>PermSCT</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.PermSCT"></base-input>
        </div>
        <div class="col-sm-4">
          <label>NumPermisoSCT</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.NumPermisoSCT"></base-input>
        </div>
        <div class="col-sm-4">
          <label>Config vehicular</label>
          <base-input class="input-group-alternative mb-3" v-model="vehiculo_selected.configuracion_vehicular"></base-input>
        </div>
      </div>

      <template slot="footer">
        <base-button
            type="success"
            v-if="vehiculo_selected.cedis !== '- Nuevo vehiculo' && vehiculo_selected.cedis"
            @click="saveChangesVehiculo(vehiculo_selected)"
          >Guardar cambios</base-button>
        <base-button
            type="success"
            v-if="vehiculo_selected.cedis === '- Nuevo vehiculo'"
            @click="crearVehiculo(nuevo_vehiculo)"
          >Crear vehiculo</base-button>
        <base-button type="link" @click="modals.modal7 = false">Cerrar</base-button>
      </template>
    </modal>

    <modal :show.sync="modals.modal9">
        <h2 slot="header" class="modal-title" id="modal-title-default">Descargar PoD</h2>
        <div class="row">
          <div class="col-sm-8">
            <flat-pickr
              v-model="pod_fecha"
              :config="{ dateFormat: 'Y-m-d', mode: 'range' }"
              class="form-control"
              placeholder="Selecciona un rango de fechas"
              />
          </div>
          <div class="col-sm-4 justify-content-end d-flex align-items-center">
            <base-button type="primary" class="ml-auto" @click="descargarPoD">Descargar</base-button>
          </div>
        </div>
    </modal>

    <div class="container-fluid mt--9" style="margin-top:-9">
      <div class="row">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <div slot="header" class="row" style="padding-left:10px;">
              <!-- <base-button slot="title" type="secondary" @click="$router.replace('kpi')">KPI Form</base-button> -->
              <base-button slot="title" type="secondary" @click="openExistencias">Existencias</base-button>
              <base-button slot="title" type="secondary" @click="openDescargarPoD">Descargar PoD</base-button>
              <base-button
                slot="title"
                type="secondary"
                @click="openUsuariosTraslados"
                v-if="user.email == 'alfredoreyes@canplast.com.mx' || user.email == 'salvadorbarbosa@canplast.com.mx' || user.email == 'danieljimenez@canplast.com.mx' || user.email == 'brendaterrazas@canplast.com.mx' || user.email == 'brendaterrazas@canplast.com.mx' || user.email == 'alejandrorojas@canplast.com.mx'"
              >Usuarios Traslados</base-button>
            </div>
            <div slot="header" class="row" style="padding-left:10px;padding-top:10px">
              <base-button
                slot="title"
                type="secondary"
                @click="openChoferes"
                v-if="user.email == 'alfredoreyes@canplast.com.mx' || user.email == 'salvadorbarbosa@canplast.com.mx' || user.email == 'danieljimenez@canplast.com.mx' || user.email == 'brendaterrazas@canplast.com.mx' || user.email == 'brendaterrazas@canplast.com.mx' || user.email == 'alejandrorojas@canplast.com.mx'"
              >Choferes</base-button>
              <base-button
                slot="title"
                type="secondary"
                @click="openVehiculos"
                v-if="user.email == 'alfredoreyes@canplast.com.mx' || user.email == 'salvadorbarbosa@canplast.com.mx' || user.email == 'danieljimenez@canplast.com.mx' || user.email == 'brendaterrazas@canplast.com.mx' || user.email == 'brendaterrazas@canplast.com.mx' || user.email == 'alejandrorojas@canplast.com.mx'"
              >Vehiculos</base-button>
              <base-button
                slot="title"
                type="secondary"
                @click="openCalendar()"
                v-if="user.email == 'alfredoreyes@canplast.com.mx' || user.email == 'salvadorbarbosa@canplast.com.mx' || user.email == 'omarandresgarza@canplast.com.mx' || user.email == 'brendaterrazas@canplast.com.mx' || user.email == 'lizethflores@canplast.com.mx' || user.email == 'edricbaeza@canplast.com.mx' || user.email == 'elesbantrevizo@canplast.com.mx' || user.email == 'aaronroman@canplast.com.mx' || user.email == 'rebecahernandez@canplast.com.mx' || user.email == 'carloshernandez@canplast.com.mx' || user.email == 'evelynloera@canplast.com.mx' || user.email == 'leonardosantos@canplast.com.mx' || user.email == 'octaviojuarez@canplast.com.mx' || user.email == 'jesusaguilar@canplast.com.mx' || user.email == 'edwinpuc@canplast.com.mx' || user.email == 'abrahamguerra@canplast.com.mx' || user.email == 'joelmedina@canplast.com.mx' || user.email == 'concepcionnuno@canplast.com.mx' || user.email == 'leslysifuentes@canplast.com.mx'"
              >Ver Calendario ADUANA</base-button>
            </div>
            <div class="row align-items-center">
              <div class="col">
                <iframe
                  src="https://datastudio.google.com/embed/reporting/1J1Z8O3YKUDuW_s3Oz0E8kbf99zeweVtO/page/tZyRB"
                  style="width: 100%; height: 800px;"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col">
                <iframe
                  src="https://datastudio.google.com/embed/reporting/1J1Z8O3YKUDuW_s3Oz0E8kbf99zeweVtO/page/uemRB"
                  style="width: 100%; height: 930px;"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col">
                <iframe
                  src="https://datastudio.google.com/embed/reporting/1J1Z8O3YKUDuW_s3Oz0E8kbf99zeweVtO/page/P7tRB"
                  style="width: 100%; height: 720px;"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { getAuth, getIdToken } from "firebase/auth";
import { 
  getFirestore, collection, query, where, orderBy, getDocs, addDoc, updateDoc, doc 
} from "firebase/firestore";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import axios from "axios";
import "flatpickr/dist/flatpickr.css";
import { ExportToCsv } from "export-to-csv";


export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      modals: {
        modal1: false,
        modal2: false,
        modal3: false,
        modal4: false,
        modal5: false,
        modal6: false,
        modal7: false,
        modal8: false,
        modal9: false,
      },
      showExistenciaResult: false,
      fileData: null,
      uploadValue: 0,
      file: null,
      archivoProcesado: null,
      user: null,
      checadorDate: null,
      options_productos: [],
      producto_selected: {},
      existencia_producto: [],
      showLoaderExistencia: false,
      cotizacion: null,
      usersTraslados: [],
      usersChoferes: [],
      vehiculos: [{
        cedis:"- Nuevo vehiculo",
        marca:"",
        modelo:"",
        placa:"",
        poliza:"",
      }],
      vehiculosList:[],
      nuevo_cedis: null,
      nuevo_nombre: null,
      nuevo_pin: null,
      user_selected: null,
      chofer_selected:null,
      pod_fecha: null,
      vehiculo_selected: {},
      nuevo_vehiculo: {
        marca: null,
        cedis: null,
        modelo: null,
        placa: null,
        poliza: null,
        aseguradora: null,
        configuracion_vehicular: null,
        NumPermisoSCT: null,
        PermSCT: null
      },
      showModifyUser: false,
      showNewUser: false,
      showModifyChofer: false,
      showNewChofer: false,
      showModifyVehiculo: false,
      showNewVehiculo: false,
      num_cobro: null,
      cobroSelected: null,
      vehiculoDataChofer: null,
      cancelacionDocNum: null,
      facturaParaCancelar: null,
      motivoCancelacion: "Selecciona el motivo",
    };
  },
  methods: {
    async descargarPoD() {
      if (this.pod_fecha) {
        const date = this.pod_fecha.split(" to ");
        const db = getFirestore();
        const podCol = collection(db, "pod");
        const q = query(
          podCol,
          where(
            "timestamp",
            ">=",
            moment(moment(date[0]).format("YYYY-MM-DD")).format("x")
          ),
          where(
            "timestamp",
            "<=",
            moment(moment(date[1]).format("YYYY-MM-DD")).format("x")
          )
        );
        try {
          const querySnapshot = await getDocs(q);
          console.log(
            "🚀 ~ Descargar PoD, querySnapshot size:",
            querySnapshot.size
          );
          let data = [];
          querySnapshot.forEach((doc) => {
            data.push(doc.data());
          });
          this.download_csv(data);
        } catch (error) {
          console.error("Error descargando PoD:", error);
        }
      } else {
        Swal.fire({
          title: "Error",
          text: "Selecciona una fecha",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    },
    download_csv(data) {
      const options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        filename: "pod",
      };

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(data);
    },
    customVehiculos({ cedis, marca, modelo, placa }) {
      if (cedis) {
        return `${cedis} - ${marca} ${modelo} ${placa}`;
      }
    },
    async crearVehiculo(vehiculo) {
      const db = getFirestore();
      const vehiculosCol = collection(db, "vehiculos");
      const q = query(vehiculosCol, where("placa", "==", this.nuevo_vehiculo.placa));
      try {
        const querySnapshot = await getDocs(q);
        if (querySnapshot.size === 0) {
          await addDoc(vehiculosCol, vehiculo);
          this.nuevo_vehiculo = {
            marca: null,
            cedis: null,
            modelo: null,
            placa: null,
            poliza: null,
            aseguradora: null,
            configuracion_vehicular: null,
            NumPermisoSCT: null,
            PermSCT: null,
          };
          this.load();
          alert("El vehiculo ha sido creado correctamente");
        } else {
          alert("Ya existe un vehiculo con este número de placas " + vehiculo.placa);
        }
      } catch (error) {
        alert("Hubo un error al crear el vehiculo: " + error);
      }
    },
    async saveChangesVehiculo(vehiculo) {
      const db = getFirestore();
      const vehiculosCol = collection(db, "vehiculos");
      const q = query(vehiculosCol, where("placa", "==", vehiculo.placa));
      try {
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          const vehiculoDoc = querySnapshot.docs[0];
          const vehiculoDocRef = doc(db, "vehiculos", vehiculoDoc.id);
          await updateDoc(vehiculoDocRef, {
            marca: vehiculo.marca,
            modelo: vehiculo.modelo,
            placa: vehiculo.placa,
            poliza: vehiculo.poliza,
            aseguradora: vehiculo.aseguradora,
            configuracion_vehicular: vehiculo.configuracion_vehicular,
            NumPermisoSCT: vehiculo.NumPermisoSCT,
            PermSCT: vehiculo.PermSCT,
          });
          this.load();
          alert("Los datos del vehiculo han sido modificados correctamente");
        }
      } catch (error) {
        console.error("Error actualizando vehiculo:", error);
      }
    },
    async saveChangesChofer(chofer) {
      const db = getFirestore();
      const usersCol = collection(db, "users");
      const q = query(usersCol, where("telefono", "==", chofer.telefono));
      try {
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          const choferDoc = querySnapshot.docs[0];
          const choferDocRef = doc(db, "users", choferDoc.id);
          await updateDoc(choferDocRef, {
            cedis: chofer.cedis,
            nombre: chofer.nombre,
            telefono: chofer.telefono,
            codigo_postal: chofer.codigo_postal,
            calle: chofer.calle,
            exterior: chofer.exterior,
            colonia: chofer.colonia,
            licencia: chofer.licencia,
            rfc: chofer.rfc,
            vehiculo: chofer.vehiculoid,
          });
          this.load();
          alert("Los datos del chofer han sido modificados correctamente");
        }
      } catch (error) {
        console.error("Error actualizando chofer:", error);
      }
    },
    openCalendar() {
      this.$router.push({ path: "calendario/aduana" });
    },
    openExistencias() {
      this.modals.modal2 = true;
    },
    openUsuariosTraslados() {
      this.modals.modal4 = true;
    },
    openChoferes() {
      this.modals.modal6 = true;
    },
    openVehiculos() {
      this.modals.modal7 = true;
    },
    openDescargarPoD() {
      this.modals.modal9 = true;
    },
    // cancelarFactura(id) {
    //   // Lógica de cancelación (comentada en el original)
    // },
    dispatchActionUser() {
      this.showModifyUser = true;
      this.showNewUser = false;
    },
    dispatchActionChofer(data) {
      this.showModifyChofer = true;
      this.showNewChofer = false;
      this.vehiculoDataChofer = null;
      if (data.vehiculo) {
        this.vehiculoDataChofer = this.vehiculosList.find((x) => x.id === data.vehiculo);
      }
    },
    dispatchActionVehiculo(data) {
      this.chofer_selected.vehiculoid = data.id;
    },
    dispatchActionProducto() {
      this.showExistenciaResult = false;
      this.showLoaderExistencia = true;
      this.producto_selected = {};
      setTimeout(() => {
        axios
          .get(`/api/orders/merch_orders/${this.producto_selected.ItemCode}`)
          .then((result) => {
            this.producto_selected.pps = result.data.value;
          })
          .catch(() => {
            Swal.fire("Error", "No se pudo conectar con el servidor", "error");
          });

        axios
          .get(`/api/purchase_orders/time/${this.producto_selected.ItemCode}`)
          .then((result) => {
            this.producto_selected.llegadas = result.data.value;
          })
          .catch(() => {
            Swal.fire("Error", "No se pudo conectar con el servidor", "error");
          });

        fetch(
          "https://canplast.net:50000/api/v1/sap/GET/ItemPrice/" + this.producto_selected.ItemCode,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "x-access-token": localStorage.getItem("token-cpm"),
            },
          }
        )
          .then((response) => response.json())
          .then((responseJson) => {
            this.producto_selected.ItemWarehouseInfoCollection = [];
            responseJson.ItemWarehouseInfoCollection.forEach((element) => {
              if (element.InStock > 0 || element.Committed > 0) {
                this.producto_selected.ItemWarehouseInfoCollection.push(element);
              }
            });
            this.showExistenciaResult = true;
            this.showLoaderExistencia = false;
          })
          .catch(() => {
            Swal.fire("Error", "No se pudo conectar con el servidor", "error");
          });
      }, 500);
    },
    moment() {
      return moment();
    },
    async createUserTraslados() {
      const db = getFirestore();
      try {
        const usersCol = collection(db, "users");
        const docRef = await addDoc(usersCol, {
          cedis: this.nuevo_cedis,
          nombre: this.nuevo_nombre,
          pin: this.nuevo_pin,
          tipo: "traslados",
        });
        this.nuevo_pin = null;
        this.nuevo_nombre = null;
        this.nuevo_cedis = null;
        alert(docRef.id);
      } catch (error) {
        alert("Hubo un error al crear el usuario: " + error);
      }
    },
    async load() {
      const db = getFirestore();
      this.usersChoferes = [];
      this.vehiculos = [
        {
          cedis: "- Nuevo vehiculo",
          marca: "",
          modelo: "",
          placa: "",
          poliza: "",
        },
      ];
      // Cargar choferes (delivery)
      try {
        const usersCol = collection(db, "users");
        const q = query(usersCol, where("tipo", "==", "delivery"));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          this.usersChoferes.push(doc.data());
        });
      } catch (error) {
        console.error("Error cargando usersChoferes:", error);
      }
      // Cargar vehiculos
      try {
        const vehiculosCol = collection(db, "vehiculos");
        const q = query(vehiculosCol, orderBy("cedis"));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          this.vehiculos.push(doc.data());
        });
      } catch (error) {
        console.error("Error cargando vehiculos:", error);
      }
      // Cargar vehiculosList
      try {
        const vehiculosCol = collection(db, "vehiculos");
        const q = query(vehiculosCol, orderBy("cedis"));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          this.vehiculosList.push({
            id: doc.id,
            aseguradora: doc.data().aseguradora,
            cedis: doc.data().cedis,
            marca: doc.data().marca,
            modelo: doc.data().modelo,
            placa: doc.data().placa,
            poliza: doc.data().poliza,
          });
        });
      } catch (error) {
        console.error("Error cargando vehiculosList:", error);
      }
    },
  },
  async mounted() {
    const db = getFirestore();
    try {
      const usersCol = collection(db, "users");
      const q = query(usersCol, where("tipo", "==", "traslados"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        this.usersTraslados.push(doc.data());
      });
    } catch (error) {
      console.error("Error cargando usersTraslados:", error);
    }
    this.load();
    try {
      const response = await fetch("https://canplast.net:50000/api/v1/sap/GET/ProductsList", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("token-cpm"),
        },
      });
      const responseJson = await response.json();
      this.options_productos = responseJson.value;
    } catch (error) {
      Swal.fire("Error", "No se pudo conectar con el servidor", "error");
    }
    try {
      const response = await fetch("https://canplast.net:50000/api/v1/sap/GET/Quotation/33669", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("token-cpm"),
        },
      });
      const responseJson = await response.json();
      this.cotizacion = responseJson.value[0];
    } catch (error) {
      Swal.fire("Error", "No se pudo conectar con el servidor", "error");
    }
  },
  async created() {
    const auth = getAuth();
    this.user = auth.currentUser;
    try {
      const idToken = await getIdToken(auth.currentUser, true);
      const response = await fetch("https://canplast.net:50000/api/v1/auth/verifyToken", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: idToken }),
      });
      const responseJson = await response.json();
      localStorage.setItem("token-cpm", responseJson.token);
    } catch (error) {
      Swal.fire("Error", "No se pudo conectar con el servidor", "error");
    }
  },
};
</script>
<style></style>
